// extracted by mini-css-extract-plugin
export default {"uploadFileBtn":"InputImage_uploadFileBtn__I1zx8","attachList":"InputImage_attachList__XqUex","attachImage":"InputImage_attachImage__sPL-C"};